import { render, staticRenderFns } from "./_arrival.vue?vue&type=template&id=5fab4e82"
import script from "./_arrival.vue?vue&type=script&lang=js"
export * from "./_arrival.vue?vue&type=script&lang=js"
import style0 from "./_arrival.vue?vue&type=style&index=0&id=5fab4e82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RzStatusHeader: require('/opt/razlet.ru.v2/node_modules/@razlet/ui/src/components/status-header/index.vue').default,RzIconArrow: require('/opt/razlet.ru.v2/node_modules/@razlet/ui/src/icons/icon-arrow/index.vue').default,RzCheckbox: require('/opt/razlet.ru.v2/node_modules/@razlet/ui/src/components/checkbox/index.vue').default,RzPreloader: require('/opt/razlet.ru.v2/node_modules/@razlet/ui/src/components/preloader/index.vue').default,RzIconInfo: require('/opt/razlet.ru.v2/node_modules/@razlet/ui/src/icons/icon-info/index.vue').default,RzIconClockOutline: require('/opt/razlet.ru.v2/node_modules/@razlet/ui/src/icons/icon-clock-outline/index.vue').default,RzIconDistance: require('/opt/razlet.ru.v2/node_modules/@razlet/ui/src/icons/icon-distance/index.vue').default,RzContainer: require('/opt/razlet.ru.v2/node_modules/@razlet/ui/src/components/container/index.vue').default})
